import React from "react";
import CopyPopper from "@hyro-components/CopyPopper";
import CopyIcon from "src/icons/CopyIcon";
import { Wrapper, StyledIconButton } from "./CopyPaste.commons";
import { TYPES, LAYOUTS } from "./CopyPaste.consts";
import { useTheme } from "@mui/material";

const FieldCopy = ({ value, zIndex, useWrapper = false, type = TYPES.ELAVATED, iconSize = 14, buttonSize, popperText, layout = LAYOUTS.CIRCLE }) => {
  const theme = useTheme();
  return <Wrapper useWrapper={useWrapper} type={type}>
    <CopyPopper popperText={popperText || "Copied"} copyText={value} stopPropagation zIndex={zIndex}>
      <StyledIconButton type={type} size={buttonSize} layout={layout} data-testid="copy-button">
        <CopyIcon size={iconSize} style={{ flexShrink: 0, width: `${iconSize}px`, height: `${iconSize}px` }} strokeOpacity={1} color={theme.palette.text[700]} />
      </StyledIconButton>
    </CopyPopper>
  </Wrapper>;
};

export default FieldCopy;
